import { FC, useState } from 'react'
import { RankingTable } from './RankingTable'
import { RankingInfoBox } from './RankingInfoBox'
import { EmployeeAndTag, CompanyRankingSettingsDto, Country, EmployeeTagType } from '../../types'
import { useTranslation } from 'react-i18next'
import { MessageBox } from '../../components/custom_components/MessageBox/MessageBox'
import { RankingTopTagConfirmationButton } from './RankingTopTagConfirmationButton'

export type RankingViewContentProps = {
  data: EmployeeAndTag[]
  companyId: string
  country: Country
  settings: CompanyRankingSettingsDto
}

export const RankingViewContent: FC<RankingViewContentProps> = ({ data, companyId, country, settings }) => {
  const { t } = useTranslation()
  const [topTagConfirmed, setTopTagConfirmation] = useState<boolean>(false)

  const topTagMissing =
    !!settings.tagAssignmentIsInProgress && !data.some((employeeTag) => employeeTag.tags.some((tag) => tag.type === EmployeeTagType.Top))

  return (
    <>
      {!settings.rankingIsDisabled && (
        <>
          <RankingInfoBox infoBoxData={data} companyId={companyId} country={country} settings={settings} />
          {(!!settings.tagAssignmentIsInProgress || topTagMissing) && (
            <MessageBox
              icon="warning_fill"
              iconBackground="warning"
              message={t('rankingView.messages.confirmationNotDone')}
              description={t('rankingView.messages.confirmationNotDoneDescription')}
            />
          )}
          {!settings.tagAssignmentIsInProgress && topTagConfirmed && (
            <MessageBox
              icon="check_stroke"
              iconBackground="success"
              message={t('rankingView.modalTopTagConfirmation.confirmationDone')}
              description={t('rankingView.messages.confirmationDoneDescription')}
            />
          )}
        </>
      )}
      <RankingTable
        tableData={settings.rankingIsDisabled ? [] : data}
        companyId={companyId}
        settings={settings}
        country={country}
        isMessageBoxVisible={topTagConfirmed || !!settings.tagAssignmentIsInProgress || topTagMissing}
      />
      {!settings.rankingIsDisabled && !!settings.tagAssignmentIsInProgress && (
        <RankingTopTagConfirmationButton
          companyId={companyId}
          country={country}
          employeeAndTags={data}
          companySettings={settings}
          setTopTagConfirmation={setTopTagConfirmation}
        />
      )}
    </>
  )
}
